import {post} from '../request'



/**
 * 用户登录
 * @param data
 * @returns {*}
 */
export function Login(data) {
	return post("admin/passport/login", data)
}

export function captcha(data) {
	return post("admin/passport/verify", data)
}
